import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { DelayReason } from '../../../entities/DelayReason';
import ModalWrapper from '../ModalWrapper';

type Props = {
  isShow: boolean;
  reasons: DelayReason[];
  loading?: boolean;
  error?: string;
  title: string;
  closeModal: () => void;
  acceptHandler: (comment: { id: number; commentText: string }) => void;
  isStatusConfirmation?: boolean;
  statusAcceptHandler?: () => void;
};

const TripStatusReasonModal: React.FC<Props> = ({
  isShow,
  reasons,
  loading = false,
  error,
  title,
  closeModal,
  acceptHandler,
  isStatusConfirmation = false,
  statusAcceptHandler,
}) => {
  const [selectedId, setSelectedId] = useState<number | ''>('');
  const [manualText, setManualText] = useState('');
  const [errorText, setErrorText] = useState('');
  const selectedReason = reasons.find((reason) => reason.id === selectedId);

  useEffect(() => {
    if (!isShow) {
      setSelectedId('');
      setManualText('');
      setErrorText('');
    }
  }, [isShow]);

  const handleAccept = () => {
    if (!selectedReason) {
      setErrorText('Оберіть причину');
      return false;
    }

    if (selectedReason.isManual === 1 || selectedReason.isManual === true) {
      if (!manualText.trim()) {
        setErrorText('Вкажіть причину');
        return false;
      }
    }

    acceptHandler({
      id: selectedReason.id,
      commentText:
        selectedReason.isManual === 1 || selectedReason.isManual === true
          ? manualText.trim()
          : selectedReason.commentText,
    });
    return true;
  };

  return (
    <ModalWrapper show={isShow} onHide={closeModal} title={title}>
      {loading ? <div className="text-center">Завантаження...</div> : null}
      {error ? <div className="text-danger mb-3">{error}</div> : null}
      {!loading && !error ? (
        <>
          <Form.Group>
            <Form.Label>Причина переведення</Form.Label>
            <Form.Control
              as="select"
              value={selectedId}
              onChange={(event) => {
                setSelectedId(event.target.value ? Number(event.target.value) : '');
                setErrorText('');
              }}
            >
              <option value="">Оберіть причину</option>
              {reasons.map((reason) => (
                <option key={reason.id} value={reason.id}>
                  {reason.commentText}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          {selectedReason && (selectedReason.isManual === 1 || selectedReason.isManual === true) ? (
            <Form.Control
              as="textarea"
              className="mt-3"
              value={manualText}
              onChange={(event) => {
                setManualText(event.target.value);
                setErrorText('');
              }}
              placeholder="Вкажіть причину"
            />
          ) : null}
          {errorText ? <div className="text-danger mt-2">{errorText}</div> : null}
          <div className="d-flex justify-content-around mt-4">
            {isStatusConfirmation && (
              <Button className="mr-4 px-5" variant="outline-secondary" onClick={closeModal}>
                Ні
              </Button>
            )}
            <Button
              className="px-5"
              variant={isStatusConfirmation ? 'outline-danger' : 'outline-secondary'}
              onClick={() => {
                const isAccepted = handleAccept();
                if (isAccepted && isStatusConfirmation && statusAcceptHandler) statusAcceptHandler();
              }}
              disabled={!reasons.length}
            >
              {isStatusConfirmation ? 'Так' : 'Підтвердити'}
            </Button>
          </div>
        </>
      ) : null}
    </ModalWrapper>
  );
};

export default TripStatusReasonModal;
